const SortName = {
  TOPSELLER: "topseller",
  DATE_NEWEST: "date_newest",
  PRICE_DESC: "price_desc",
  PRICE_ASC: "price_asc",
  REDUCTION_DESC: "reduction_desc",
  REDUCTION_ASC: "reduction_asc"
};
const SortQuery = {
  TOPSELLER: "topseller",
  DATE_NEWEST: "date-newest",
  PRICE_DESC: "price-desc",
  PRICE_ASC: "price-asc",
  REDUCTION_DESC: "reduction-desc",
  REDUCTION_ASC: "reduction-asc"
};
export { SortName, SortQuery };
